import React, { useState, lazy, Suspense } from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import { DataProvider } from './context/DataContext';
import ScrollEarnings from './components/ScrollEarnings';
import './styles/App.css';
import Citations from './components/Citations';

// Lazy load components with charts
const WealthComparison = lazy(() => import('./components/WealthComparison'));
const BillionaireImpact = lazy(() => import('./components/BillionaireImpact'));
const LiveWealth = lazy(() => import('./components/LiveWealth'));
const Solutions = lazy(() => import('./components/Solutions'));

function App() {
  const [sharedSalary, setSharedSalary] = useState(50000);

  const handleSalaryChange = (newSalary) => {
    // Preserve 0 for an empty/cleared input so downstream components can show
    // their "enter your salary" prompt instead of dividing by it.
    const numeric = Number(newSalary);
    setSharedSalary(Number.isFinite(numeric) && numeric > 0 ? numeric : 0);
  };

  return (
    <DataProvider>
      <div className="App">
        <Navbar />
        <main>
          <section id="home">
            <Home />
          </section>
          <Suspense fallback={<div className="loading-state">Loading impact data...</div>}>
            <section id="billionaire-impact">
              <BillionaireImpact />
            </section>
          </Suspense>
          <Suspense fallback={<div className="loading-state">Loading live wealth data...</div>}>
            <section id="live-wealth">
              <LiveWealth salary={sharedSalary} onSalaryChange={handleSalaryChange} />
            </section>
          </Suspense>
          <Suspense fallback={<div className="loading-state">Loading wealth comparison data...</div>}>
            <section id="wealth-comparison">
              <WealthComparison salary={sharedSalary} onSalaryChange={handleSalaryChange} />
            </section>
          </Suspense>
          <Suspense fallback={<div className="loading-state">Loading solutions...</div>}>
            <section id="solutions">
              <Solutions />
            </section>
          </Suspense>
          <section id="data-sources">
            <Citations />
          </section>
          <section id="scroll-earnings">
            <ScrollEarnings />
          </section>
        </main>
      </div>
    </DataProvider>
  );
}

export default App; 